export default {
  title: 'Reservationer som CSV',
  buttons: {
    generate: 'Generer og download',
  },
  fields: {
    date_range: 'Datointerval (valgfrit)',
  },
  errors: {
    invalid_date_range: 'Vælg et gyldigt datointerval',
  },
};
